"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemDivider = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../../theme/colors");
function MenuItemDivider() {
    return react_1.default.createElement(StyledDivider, null);
}
exports.MenuItemDivider = MenuItemDivider;
var StyledDivider = styled_components_1.default.hr(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  border: 0;\n  margin: 8px 0;\n  height: 1px;\n  background-color: ", ";\n"], ["\n  border: 0;\n  margin: 8px 0;\n  height: 1px;\n  background-color: ", ";\n"])), colors_1.colors.steel[200]);
var templateObject_1;
//# sourceMappingURL=divider.js.map